export default {"src":"/_next/static/media/Pulmonary_Hypertension.dd79c634.svg","height":51,"width":51,"blurWidth":0,"blurHeight":0};